import "./MobileNavbar.scss";
import { changeItemSelection } from "@/helpers/commonHelper";

export default {
  name: "MobileNavbar",
  props: ["mobileMenuOpen", "modules"],
  data: () => ({
    expandedGroupId: null
  }),
  async mounted() {
    await this.$store.dispatch("getNavbarItems");
    if (!this.user) {
      await this.$store.dispatch("getCurrentUser");
    }
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    adminModules() {
      return Array.isArray(this.modules)
        ? this.modules.filter(m => m.name === "Administration")
        : [];
    },
    appModules() {
      return Array.isArray(this.modules)
        ? this.modules.filter(m => m.name !== "Administration")
        : [];
    }
  },
  methods: {
    changeItemSelection(item, isSub) {
      this.$emit("closeMenu");
      changeItemSelection(item, isSub);
    },
    toggleGroup(itemId) {
      this.expandedGroupId = this.expandedGroupId === itemId ? null : itemId;
    },
    isGroupExpanded(item) {
      if (this.expandedGroupId !== null) {
        return this.expandedGroupId === item.id;
      }
      return !!item.selected;
    },
    async logout() {
      localStorage.removeItem("authRefreshToken");
      localStorage.removeItem("session");
      localStorage.removeItem("impersonatedBy");
      localStorage.removeItem("selectedPrincipal");
      this.$store.state.session = null;
      this.$store.state.currentUser = null;
      this.$store.state.modules = null;
      window.location.href = "/login";
    }
  },
  watch: {
    mobileMenuOpen(isOpen) {
      if (!isOpen) {
        this.expandedGroupId = null;
      }
    }
  }
};
